import { useState } from 'react'
import textServices from 'services/text-services'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import { AFTERWORK_ASSETS, AFTERWORK_IMAGES, NEXT_EVENT } from '../constants'

const trackParticipate = (element: string) =>
  dlTrackEvent('user_interaction', { action: 'click', element, link: 'whatsapp', section: 'afterwork' })

interface NextEditionSectionProps {
  onCtaClick: () => void
}

// "La próxima edición te espera" + glass event card (Figma 43:101). Event
// data (date, city, lineup, art) lives in NEXT_EVENT (constants.ts). Missing
// CDN assets degrade: background falls to the CSS gradient, lineup art falls
// to the DOM placeholder.
const NextEditionSection = ({ onCtaClick }: NextEditionSectionProps) => {
  const [artFailed, setArtFailed] = useState(false)

  return (
    <section className="afterwork__next" id="afterwork-next-event">
      <picture>
        <source
          media="(min-width: 768px)"
          srcSet={encodeURI(`${AFTERWORK_ASSETS}/${AFTERWORK_IMAGES.nextBackgroundDesktop}`)}
        />
        <img
          className="afterwork__next-bg"
          src={encodeURI(`${AFTERWORK_ASSETS}/${AFTERWORK_IMAGES.nextBackgroundMobile}`)}
          alt=""
        />
      </picture>
      <div className="afterwork__next-content">
        <h2 className="afterwork__next-title">
          {textServices.findByText('afterwork/next/title', 'La próxima edición te espera')}
        </h2>
        <p className="afterwork__next-description">
          {textServices.findByText(
            'afterwork/next/description',
            'Porque no hay mejor forma de cerrar una semana intensa que con una cerveza de calidad y 100% pura malta.'
          )}
        </p>

        <div className="afterwork__next-card">
          <div className="afterwork__next-card-copy">
            <h3 className="afterwork__next-card-title">
              {textServices.findByText('afterwork/next/cardTitle', 'Próximo Afterwork:')}
            </h3>
            <span className="afterwork__next-card-date">{NEXT_EVENT.dateLabel}</span>
            <p className="afterwork__next-card-text">
              {textServices.findByText(
                'afterwork/next/cardText',
                'Contesta una pregunta y participa por una invitación.'
              )}
            </p>
            <button
              type="button"
              className="home-v3__button afterwork__cta"
              onClick={() => {
                trackParticipate('proximo afterwork :: ¡quiero participar!')
                onCtaClick()
              }}
            >
              {textServices.findByText('afterwork/next/cardCta', '¡Quiero participar!')}
            </button>
            <p className="afterwork__next-card-legal">
              {textServices.findByText(
                'afterwork/next/cardLegal',
                'Heineken access only — Únicamente con invitación.'
              )}
            </p>
          </div>

          {NEXT_EVENT.image && !artFailed ? (
            <picture className="afterwork__next-card-art-wrap">
              {NEXT_EVENT.imageDesktop && (
                <source
                  media="(min-width: 768px)"
                  srcSet={encodeURI(`${AFTERWORK_ASSETS}/${NEXT_EVENT.imageDesktop}`)}
                />
              )}
              <img
                className="afterwork__next-card-art"
                src={encodeURI(`${AFTERWORK_ASSETS}/${NEXT_EVENT.image}`)}
                alt={`Afterwork ${NEXT_EVENT.city}: ${NEXT_EVENT.lineup.join(' & ')}`}
                onError={() => setArtFailed(true)}
              />
            </picture>
          ) : (
            // Placeholder until the lineup art reaches the CDN
            <div className="afterwork__next-card-art afterwork__next-card-art--placeholder">
              <span>Afterwork</span>
              {NEXT_EVENT.lineup.map((artist) => (
                <strong key={artist}>{artist}</strong>
              ))}
              <span>{NEXT_EVENT.dateLabel}</span>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default NextEditionSection
